import { defineComponent as s, openBlock as a, createElementBlock as t, mergeProps as d, unref as l, renderSlot as p, createElementVNode as o, createCommentVNode as V } from "vue";
import { useScalarIcon as h } from "../hooks/useScalarIcon.js";
const i = { key: 0 }, u = { key: 1 }, v = { key: 2 }, M = { key: 3 }, g = { key: 4 }, A = { key: 5 }, f = {
  name: "ScalarIconBank"
}, y = /* @__PURE__ */ s({
  ...f,
  props: {
    label: {},
    weight: {}
  },
  setup(n) {
    const Z = n, { bind: m, weight: e } = h(Z);
    return (r, H) => (a(), t("svg", d({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, l(m)), [
      p(r.$slots, "default"),
      l(e) === "bold" ? (a(), t("g", i, H[0] || (H[0] = [
        o("path", { d: "M24,108H44v48H32a12,12,0,0,0,0,24H224a12,12,0,0,0,0-24H212V108h20a12,12,0,0,0,6.29-22.22l-104-64a12,12,0,0,0-12.58,0l-104,64A12,12,0,0,0,24,108Zm44,0H92v48H68Zm72,0v48H116V108Zm48,48H164V108h24ZM128,46.09,189.6,84H66.4ZM252,208a12,12,0,0,1-12,12H16a12,12,0,0,1,0-24H240A12,12,0,0,1,252,208Z" }, null, -1)
      ]))) : l(e) === "duotone" ? (a(), t("g", u, H[1] || (H[1] = [
        o("path", {
          d: "M232,96H24L128,32Z",
          opacity: "0.2"
        }, null, -1),
        o("path", { d: "M24,104H48v64H32a8,8,0,0,0,0,16H224a8,8,0,0,0,0-16H208V104h24a8,8,0,0,0,4.19-14.81l-104-64a8,8,0,0,0-8.38,0l-104,64A8,8,0,0,0,24,104Zm40,0H96v64H64Zm80,0v64H112V104Zm48,64H160V104h32ZM128,41.39,203.74,88H52.26ZM248,208a8,8,0,0,1-8,8H16a8,8,0,0,1,0-16H240A8,8,0,0,1,248,208Z" }, null, -1)
      ]))) : l(e) === "fill" ? (a(), t("g", v, H[2] || (H[2] = [
        o("path", { d: "M248,208a8,8,0,0,1-8,8H16a8,8,0,0,1,0-16H240A8,8,0,0,1,248,208ZM16.3,98.18a8,8,0,0,1,3.51-9l104-64a8,8,0,0,1,8.38,0l104,64A8,8,0,0,1,232,104H208v64h16a8,8,0,0,1,0,16H32a8,8,0,0,1,0-16H48V104H24A8,8,0,0,1,16.3,98.18ZM144,160a8,8,0,0,0,16,0V112a8,8,0,0,0-16,0Zm-48,0a8,8,0,0,0,16,0V112a8,8,0,0,0-16,0Z" }, null, -1)
      ]))) : l(e) === "light" ? (a(), t("g", M, H[3] || (H[3] = [
        o("path", { d: "M24,102H50v68H32a6,6,0,0,0,0,12H224a6,6,0,0,0,0-12H206V102h26a6,6,0,0,0,3.14-11.11l-104-64a6,6,0,0,0-6.28,0l-104,64A6,6,0,0,0,24,102Zm38,0H98v68H62Zm84,0v68H110V102Zm48,68H158V102h36ZM128,39l82.8,51H45.2ZM246,208a6,6,0,0,1-6,6H16a6,6,0,0,1,0-12H240A6,6,0,0,1,246,208Z" }, null, -1)
      ]))) : l(e) === "regular" ? (a(), t("g", g, H[4] || (H[4] = [
        o("path", { d: "M24,104H48v64H32a8,8,0,0,0,0,16H224a8,8,0,0,0,0-16H208V104h24a8,8,0,0,0,4.19-14.81l-104-64a8,8,0,0,0-8.38,0l-104,64A8,8,0,0,0,24,104Zm40,0H96v64H64Zm80,0v64H112V104Zm48,64H160V104h32ZM128,41.39,203.74,88H52.26ZM248,208a8,8,0,0,1-8,8H16a8,8,0,0,1,0-16H240A8,8,0,0,1,248,208Z" }, null, -1)
      ]))) : l(e) === "thin" ? (a(), t("g", A, H[5] || (H[5] = [
        o("path", { d: "M24,100H52v72H32a4,4,0,0,0,0,8H224a4,4,0,0,0,0-8H204V100h28a4,4,0,0,0,2.1-7.41l-104-64a4,4,0,0,0-4.2,0l-104,64A4,4,0,0,0,24,100Zm36,0h40v72H60Zm88,0v72H108V100Zm48,72H156V100h40ZM128,36.7,217.87,92H38.13ZM244,208a4,4,0,0,1-4,4H16a4,4,0,0,1,0-8H240A4,4,0,0,1,244,208Z" }, null, -1)
      ]))) : V("", !0)
    ], 16));
  }
});
export {
  y as default
};
